var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-image"},[_c('div',{ref:"zoom",staticClass:"zoom"}),(_vm.media.image)?_c('Picture',{style:(_vm.style),attrs:{"show-spinner":false,"image":_vm.media.image,"lazy":true,"missing-icon":"exclamation-triangle","fit":"fit","optimize":"speed"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }